import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  ChatflowDuplicateRequest,
  ChatflowFlowValidationResponse,
  ChatflowListFilters,
  ChatflowRequest,
  ChatflowResponse,
  ChatflowSaveAsTemplateRequest,
  ChatflowStatus,
  ChatflowStatusRequest,
  ChatflowTemplateResponse
} from '../models/chatflow.model';

@Injectable({
  providedIn: 'root'
})
export class ChatflowApiService {
  private readonly apiUrl = `${environment.apiUrl}api/chatflows`;

  constructor(private http: HttpClient) {}

  getChatflows(filters: ChatflowListFilters): Observable<ChatflowResponse[]> {
    let params = new HttpParams().set('businessId', filters.businessId.toString());

    if (filters.status) {
      params = params.set('status', filters.status);
    }

    if (filters.type) {
      params = params.set('type', filters.type);
    }

    if (filters.search !== undefined) {
      params = params.set('search', filters.search);
    }

    return this.http.get<ChatflowResponse[]>(this.apiUrl, { params });
  }

  getChatflowById(id: number): Observable<ChatflowResponse> {
    return this.http.get<ChatflowResponse>(`${this.apiUrl}/${id}`);
  }

  createChatflow(request: ChatflowRequest): Observable<ChatflowResponse> {
    return this.http.post<ChatflowResponse>(this.apiUrl, request);
  }

  updateChatflow(id: number, request: ChatflowRequest): Observable<ChatflowResponse> {
    return this.http.put<ChatflowResponse>(`${this.apiUrl}/${id}`, request);
  }

  updateStatus(id: number, status: ChatflowStatus): Observable<ChatflowResponse> {
    const request: ChatflowStatusRequest = { status };
    return this.http.patch<ChatflowResponse>(`${this.apiUrl}/${id}/status`, request);
  }

  validatePublish(id: number): Observable<ChatflowFlowValidationResponse> {
    return this.http.get<ChatflowFlowValidationResponse>(`${this.apiUrl}/${id}/validate-publish`);
  }

  duplicateChatflow(id: number, request: ChatflowDuplicateRequest): Observable<ChatflowResponse> {
    return this.http.post<ChatflowResponse>(`${this.apiUrl}/${id}/duplicate`, request);
  }

  deleteChatflow(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  saveAsTemplate(id: number, request: ChatflowSaveAsTemplateRequest): Observable<ChatflowTemplateResponse> {
    return this.http.post<ChatflowTemplateResponse>(`${this.apiUrl}/${id}/save-as-template`, request);
  }
}
